import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { MenuGroupProps } from '../__base';
import {
  BookingIcon,
  BusIcon,
  CounterIcon,
  FleetIcon,
  HomeIcon,
  NotificationIcon,
  PassengerIcon,
  ReconciliationIcon,
  RouteAndTripIcon,
  ShipmentIcon,
  StationIcon,
  TicketConflictIcon,
  TicketIcon,
  TripCalendarIcon,
  TripDetailIcon,
} from '@/assets/icons/entities/_';
import { CompanyPermissionConfig, CompanyUrl } from '@/routers/companyRouters';

const urls = CompanyUrl.Management;
export const ManagementMenu: MenuGroupProps[] = [
  {
    groupName: 'menu.MainMenu',
    items: [
      {
        icon: <HomeIcon />,
        title: 'menu.Dashboard',
        key: 'dashboard',
        to: urls.Dashboard,
        permissions: CompanyPermissionConfig.__getPermission(urls.Dashboard),
      },
      {
        icon: <BookingIcon />,
        title: 'menu.Bookings',
        key: 'bookings',
        to: urls.Bookings,
        permissions: CompanyPermissionConfig.__getPermission(urls.Bookings),
      },
      {
        icon: <BusIcon />,
        title: 'menu.SellOnTheGoBookings',
        key: 'sell-on-the-go-bookings',
        to: urls.SellOnTheGoBookings,
        permissions: CompanyPermissionConfig.__getPermission(urls.SellOnTheGoBookings),
      },
      {
        icon: <TicketIcon />,
        title: 'menu.Tickets',
        key: 'tickets',
        to: urls.Tickets,
        permissions: CompanyPermissionConfig.__getPermission(urls.Tickets),
      },
      {
        icon: <TicketConflictIcon />,
        title: 'menu.TicketConflict',
        key: 'ticket-conflict',
        to: urls.TicketConflict,
        permissions: CompanyPermissionConfig.__getPermission(urls.TicketConflict),
      },
      {
        // P4 : ventes hors ligne gardées malgré un tarif incohérent avec l'âge, à revoir.
        icon: <TicketConflictIcon />,
        title: 'menu.TariffAgeIssues',
        key: 'tariff-age-issues',
        to: urls.TariffAgeIssues,
        permissions: CompanyPermissionConfig.__getPermission(urls.TariffAgeIssues),
      },
      {
        // P43 : avoirs émis, utilisés, soldes et échéances (lecture seule).
        icon: <FeatherIcon icon="credit-card" />,
        title: 'menu.CreditNotes',
        key: 'credit-notes',
        to: urls.CreditNotes,
        permissions: CompanyPermissionConfig.__getPermission(urls.CreditNotes),
      },
    ],
  },
  {
    groupName: 'menu.SystemSettings',
    items: [
      {
        icon: <CounterIcon />,
        title: 'menu.Registers',
        key: 'registers',
        to: urls.Registers,
        permissions: CompanyPermissionConfig.__getPermission(urls.Registers),
      },
      {
        icon: <CounterIcon />,
        title: 'menu.Terminals',
        key: 'terminals',
        to: urls.Terminals,
        permissions: CompanyPermissionConfig.__getPermission(urls.Terminals),
      },
      {
        icon: <ReconciliationIcon />,
        title: 'menu.SellOnTheGoReconciliation',
        key: 'sell-on-the-go-reconciliations',
        to: urls.SellOnTheGoReconciliations,
        permissions: CompanyPermissionConfig.__getPermission(urls.SellOnTheGoReconciliations),
      },
      {
        icon: <ReconciliationIcon />,
        title: 'menu.BaggageReconciliations',
        key: 'baggage-reconciliations',
        to: urls.BaggageReconciliations,
        permissions: CompanyPermissionConfig.__getPermission(urls.BaggageReconciliations),
      },
      {
        icon: <FleetIcon />,
        title: 'menu.Fleets',
        key: 'fleets',
        permissions: [...CompanyPermissionConfig.__getPermission(urls.SeatModels)],
        subMenu: [
          {
            title: 'menu.SeatModels',
            key: 'seat-models',
            to: urls.SeatModels,
            permissions: CompanyPermissionConfig.__getPermission(urls.SeatModels),
          },
          {
            title: 'menu.TicketClasses',
            key: 'ticket-classes',
            to: urls.TicketClasses,
            permissions: CompanyPermissionConfig.__getPermission(urls.TicketClasses),
          },
        ],
      },
      {
        icon: <BusIcon />,
        title: 'menu.Buses',
        key: 'buses',
        permissions: [...CompanyPermissionConfig.__getPermission(urls.Buses), ...CompanyPermissionConfig.__getPermission(urls.BusModels)],

        subMenu: [
          {
            title: 'menu.Buses',
            key: 'manage-buses',
            to: urls.Buses,
            permissions: CompanyPermissionConfig.__getPermission(urls.Buses),
          },

          {
            title: 'menu.BusModels',
            key: 'bus-models',
            to: urls.BusModels,
            permissions: CompanyPermissionConfig.__getPermission(urls.BusModels),
          },
        ],
      },

      {
        icon: <TripCalendarIcon />,
        title: 'menu.TripsCalendar',
        key: 'trips-calendar',
        to: urls.TripsCalendar,
        permissions: CompanyPermissionConfig.__getPermission(urls.TripsCalendar),
      },
      {
        icon: <TripDetailIcon />,
        title: 'menu.TripDetails',
        key: 'trip-details',
        to: urls.TripDetails,
        permissions: CompanyPermissionConfig.__getPermission(urls.TripDetails),
      },
      {
        icon: <RouteAndTripIcon />,
        title: 'menu.RoutesAndTrips',
        key: 'routes-and-trips',
        permissions: [
          ...CompanyPermissionConfig.__getPermission(urls.Routes),
          ...CompanyPermissionConfig.__getPermission(urls.Trips),
          ...CompanyPermissionConfig.__getPermission(urls.TicketTariffs),
          ...CompanyPermissionConfig.__getPermission(urls.BaggageTariffs),
        ],

        subMenu: [
          {
            title: 'menu.Routes',
            key: 'routes',
            to: urls.Routes,
            permissions: CompanyPermissionConfig.__getPermission(urls.Routes),
          },
          {
            title: 'menu.Trips',
            key: 'trips',
            to: urls.Trips,
            permissions: CompanyPermissionConfig.__getPermission(urls.Trips),
          },
          {
            title: 'menu.TicketTariffs',
            key: 'ticket-tariffs',
            to: urls.TicketTariffs,
            permissions: CompanyPermissionConfig.__getPermission(urls.TicketTariffs),
          },
          {
            title: 'menu.BaggageTariffs',
            key: 'baggage-tariffs',
            to: urls.BaggageTariffs,
            permissions: CompanyPermissionConfig.__getPermission(urls.BaggageTariffs),
          },
        ],
      },
      {
        icon: <ShipmentIcon />,
        title: 'menu.ShipmentManagement',
        key: 'shipment-management',
        to: urls.ShipmentManagement,
        permissions: CompanyPermissionConfig.__getPermission(urls.ShipmentManagement),
      },

      {
        icon: <StationIcon />,
        title: 'menu.Stations',
        key: 'stations',
        to: urls.Stations,
        permissions: CompanyPermissionConfig.__getPermission(urls.Stations),
      },

      {
        icon: <PassengerIcon />,
        title: 'menu.Passengers',
        key: 'passengers',
        to: urls.Passengers,
        permissions: CompanyPermissionConfig.__getPermission(urls.Passengers),
      },
      {
        icon: <NotificationIcon />,
        title: 'menu.Notifications',
        key: 'notifications',
        to: urls.Notifications,
        permissions: CompanyPermissionConfig.__getPermission(urls.Notifications),
      },
    ],
  },
];
